
import { mapGetters } from 'vuex';
import Logging from '@/logging';

export default {
	name: 'DocumentDetail',
	props: {
		document: {
			type: Object,
			required: true
		},
		documentType: {
			type: String,
			required: true
		}
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore']),
		documentNumber() {
			switch (this.documentType) {
				case 'invoice':
					return this.document.invoice_number;
				case 'credit_note':
					return this.document.credit_note_number;
				case 'debit_note':
					return this.document.debit_note_number;
				case 'payment_document':
					return this.document.payment_number;
				default:
					return null;
			}
		},
		legalEntityAddressType() {
			if (this.document.legal_entity_by_reference.address) {
				if (this.document.legal_entity_by_reference.address.hasOwnProperty('street_name')) {
					return 'FORMAL';
				} else if (this.document.legal_entity_by_reference.address.hasOwnProperty('street_name_number_box')) {
					return 'INFORMAL';
				} else {
					Logging.log('cannot determine addresstype of LE');
				}
			} else {
				Logging.log('address not available on legal entity');
			}

			return null;
		},
		recipientAddressType() {
			if (this.document.recipient_by_reference.address) {
				if (this.document.recipient_by_reference.address.hasOwnProperty('street_name')) {
					return 'FORMAL';
				} else if (this.document.recipient_by_reference.address.hasOwnProperty('street_name_number_box')) {
					return 'INFORMAL';
				} else {
					Logging.log('cannot determine addresstype of recipient');
				}
			} else {
				Logging.log('address not available on recipient');
			}

			return null;
		}
	},
	methods: {
		handleRecipientClick() {
			this.$router.push({
				name: 'recipient-detail',
				params: {
					id: this.document.recipient,
					participant: this.selectedParticipantStore
				}
			});
		}
	}
};

